import { render, staticRenderFns } from "./dashboard-view.vue?vue&type=template&id=4add9d04&"
import script from "./dashboard-view.vue?vue&type=script&lang=js&"
export * from "./dashboard-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports